import itemService from './services/item.service';
import validateService from './services/validate.service';

let sharedItemModule = angular.module('spabooker.shared.item', [])
    .factory('itemService', itemService)
    .factory('validateService', validateService)
    ;

export default sharedItemModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/item/index.js